/** Relativ tolerans för att betrakta två jämförelsetal som lika (lottningsläge). */
const TIE_EPSILON = 1e-9;
/** Delningstal för ett parti som redan tilldelats `seatsSoFar` mandat. */
export function divisorFor(seatsSoFar, firstDivisor) {
    return seatsSoFar === 0 ? firstDivisor : 2 * seatsSoFar + 1;
}
function quotient(votes, seatsSoFar, firstDivisor) {
    return votes / divisorFor(seatsSoFar, firstDivisor);
}
/**
 * Fördelar mandat enligt jämkade uddatalsmetoden för en enda valkrets
 * (som Ale kommunfullmäktige). Småpartispärren tillämpas före fördelningen.
 */
export function allocateSeats(votesInput, opts) {
    const { seats, firstDivisor, thresholdPct } = opts;
    if (seats < 0 || !Number.isInteger(seats)) {
        throw new Error(`Ogiltigt antal mandat: ${seats}`);
    }
    if (firstDivisor <= 0) {
        throw new Error(`Ogiltigt första delningstal: ${firstDivisor}`);
    }
    // Slå ihop ev. dubbletter defensivt.
    const votesByParty = new Map();
    for (const { party, votes } of votesInput) {
        if (votes < 0)
            throw new Error(`Negativt röstetal för ${party}`);
        votesByParty.set(party, (votesByParty.get(party) ?? 0) + votes);
    }
    const sumInput = [...votesByParty.values()].reduce((a, b) => a + b, 0);
    const totalValidVotes = opts.totalValidVotes ?? sumInput;
    const thresholdVotes = Math.ceil((thresholdPct / 100) * totalValidVotes);
    const seatsByParty = {};
    const eligible = [];
    const excludedByThreshold = [];
    for (const [party, v] of votesByParty) {
        seatsByParty[party] = 0;
        if (v >= thresholdVotes && v > 0)
            eligible.push(party);
        else
            excludedByThreshold.push(party);
    }
    const rounds = [];
    const ties = [];
    for (let seat = 1; seat <= seats; seat++) {
        let best = null;
        let bestQ = Number.NEGATIVE_INFINITY;
        const tiedWith = [];
        for (const party of eligible) {
            const q = quotient(votesByParty.get(party) ?? 0, seatsByParty[party] ?? 0, firstDivisor);
            if (q > bestQ * (1 + TIE_EPSILON)) {
                best = party;
                bestQ = q;
                tiedWith.length = 0;
            }
            else if (Math.abs(q - bestQ) <= bestQ * TIE_EPSILON) {
                tiedWith.push(party);
            }
        }
        if (best === null)
            break; // inga deltagande partier
        if (tiedWith.length > 0) {
            const parties = [best, ...tiedWith];
            ties.push({ seat, parties: [...parties], quotient: bestQ });
            // Deterministisk upplösning: flest totala röster, därefter bokstavsordning.
            best = parties.sort((a, b) => {
                const dv = (votesByParty.get(b) ?? 0) - (votesByParty.get(a) ?? 0);
                return dv !== 0 ? dv : a < b ? -1 : 1;
            })[0];
        }
        const partySeatsAfter = (seatsByParty[best] ?? 0) + 1;
        seatsByParty[best] = partySeatsAfter;
        rounds.push({ seat, party: best, quotient: bestQ, partySeatsAfter });
    }
    return {
        seats: seatsByParty,
        rounds,
        excludedByThreshold,
        ties,
        thresholdVotes,
        totalValidVotes,
    };
}
//# sourceMappingURL=sainteLague.js.map